var path = 'app/components/stavkaNaloga/pozicije.html';
var html = "<table cellpadding=\"1\" cellspacing=\"1\" class=\"table table-condensed no_border\"><tbody><tr><th class=\"text-center\" ng-repeat=\"pozicija in vm.items\"><a ng-click=\"vm.pozicijaClicked(pozicija)\" ng-class=\"{'btn-warning': pozicija.selected}\" class=\"btn btn-xs btn-default pozicije\">{{pozicija.broj}}</a></th></tr></tbody></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/stavkaNaloga/pozicije.html
// module id = 601
// module chunks = 0